import { NavLink, Outlet } from "react-router-dom";
import { Building2, Gauge, LayoutDashboard, LogOut, MailOpen, Users } from "lucide-react";
import { Button } from "@/components/ui/primitives";
import { useAuth } from "@/hooks/use-auth";
import { cn } from "@/lib/utils";

const items = [
  { to: "/", label: "Genel bakış", icon: LayoutDashboard },
  { to: "/organizations", label: "Organizasyonlar", icon: Building2 },
  { to: "/users", label: "Kullanıcılar", icon: Users },
  { to: "/usage", label: "Kullanım", icon: Gauge },
  { to: "/invitations", label: "Davetler", icon: MailOpen },
];

export function AppLayout() {
  const { email, signOut } = useAuth();

  return (
    <div className="flex min-h-screen flex-col">
      {/* A visibly different header from the admin panel: an operator should
          never be in doubt about which of the two they are looking at. */}
      <header className="flex items-center gap-3 bg-foreground px-4 py-3 text-background">
        <span className="text-base font-bold tracking-tight">ContactPool</span>
        <span className="rounded-sm bg-background/15 px-2 py-0.5 text-xs font-medium">
          Sistem
        </span>
        <div className="ml-auto flex items-center gap-3">
          <span className="hidden text-sm opacity-80 sm:inline">{email}</span>
          <Button
            variant="ghost"
            size="sm"
            className="text-background hover:bg-background/15"
            onClick={signOut}
          >
            <LogOut className="size-4" />
            <span className="hidden sm:inline">Çıkış</span>
          </Button>
        </div>
      </header>

      <div className="flex flex-1 flex-col md:flex-row">
        <nav className="flex gap-1 overflow-x-auto border-b border-border p-2 md:h-full md:w-56 md:flex-col md:border-b-0 md:border-r md:p-3">
          {items.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              className={({ isActive }) =>
                cn(
                  "flex shrink-0 items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                  isActive
                    ? "bg-primary/12 text-primary"
                    : "text-muted-foreground hover:bg-muted hover:text-foreground"
                )
              }
            >
              <Icon className="size-4" />
              {label}
            </NavLink>
          ))}
        </nav>
        <main className="flex-1 p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
